import styled from '@emotion/styled';
import { Grid, IconButton, lighten, Typography } from '@mui/material';
import { useAppSelector } from '@/redux/hooks';
import { selectActiveTitle } from '@/redux/selectors/titleV2Selectors';
import { PolarisIcon, TitleTypeLabel } from '@/exports/columnCommonComponents';

type SelectedParentTitleProps = {
  onReset: () => void;
};

const SelectedParentTitle = ({ onReset }: SelectedParentTitleProps) => {
  const parentTitle = useAppSelector(selectActiveTitle);

  if (!parentTitle) return null;

  return (
    <Wrapper>
      <Grid container alignItems="center">
        <Typography variant="h4" mr={2}>
          {parentTitle.name}
        </Typography>
        <TitleTypeLabel type={parentTitle.entity_type} small />
        <StyledIconButton color="default" onClick={onReset}>
          <PolarisIcon icon="undo" height={30} />
        </StyledIconButton>
      </Grid>
    </Wrapper>
  );
};

export default SelectedParentTitle;

const Wrapper = styled.div(({ theme }) => ({
  background: theme.palette.background.default,
  padding: '10px 10px 10px 20px',
  borderRadius: 13,
  display: 'flex',
  alignItems: 'center',

  '.MuiInputBase-root': {
    background: lighten(theme.palette.background.paper, 0.05)
  },

  '.MuiFormLabel-root.MuiFormLabel-root': {
    textTransform: 'capitalize'
  }
}));

const StyledIconButton = styled(IconButton)(() => ({
  opacity: 0.4,
  transition: `opacity 0.3s`,
  marginLeft: 'auto',
  '&:hover': {
    opacity: 0.8
  }
}));
